// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + "22f75f4f" + "." + "0eff21540c2b41ac" + ".js";
};